<template>
    <div id="tipConfirmPurchase" aria-hidden="true"
         class="modal modal--rebrand fade over-all modal-with-custom-content modal-with-custom-content--dark-background"
         role="dialog" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content" v-if="user">
                <div class="modal-body text-center">
                    <div class="tip-icon-container">
                        <GemFilledComponent width="48px" height="48px"/>
                    </div>

                    <div class="tip-confirm-title">
                        <span>{{ amount }}</span>
                        <span class="ml-1">{{ translate.product.credits }}</span>
                    </div>

                    <p class="tip-confirm-description" v-html="confirmText"></p>

                    <button-with-loading-component
                        :disabled="loading"
                        :loading="loading"
                        :text="translate.product.confirmPurchase"
                        class="btn btn-rebrand-primary btn-rebrand-sm w-100"
                        @click.native.prevent="onConfirm()"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GemFilledComponent from "@/components/global/icons/GemFilledComponent.vue";
import ButtonWithLoadingComponent from "@/components/global/ButtonWithLoadingComponent";
import userMixin from "@/components/mixins/userMixin";
import privateGalleriesMixin from "@/components/mixins/gallery/privateGalleriesMixin";
import localStorageMixin from "@/components/mixins/localStorageMixin";
import {regionRelativeUrl} from "@/core/utils/helpers/regions/regionUrlHelper";
import {NuxtRoutes} from "@/core/constants/v2/nuxtRoutes";

const data = () => ({
    loading: false,
    amount: 0,
    user: null,
})

function initModal(user, amount) {
    this.user = user;
    this.amount = amount;
    this.loading = false;
    setTimeout(() => {
        $(() => {
            const element = $('#tipConfirmPurchase');
            if (element && typeof element.modal === 'function') {
                element.modal('show');
            }
        });
    });
}

async function onConfirm() {
    this.loading = true;

    const [err, response] = await to(
        api.tips.confirmPurchase(this.user.id, this.amount),
    );

    if (!err && _.get(response, 'data.success') !== false) {
        this.loading = false;
        $('#tipConfirmPurchase').modal('hide');
        this.updateCurrentUser({credits: _.get(this.currentUser, 'credits', this.amount) - this.amount});
        this.$emit('tipSuccess', this.amount);
        return;
    }

    const errorData = _.get(err, 'response.data', {});

    if (_.get(errorData, 'errors.amount')) {
        this.storeTipMetaAndRedirect();
        return;
    }

    if (_.get(err, 'response.status') === 403) {
        toastr.error(this.translate.account.tips.onlyCustomersCanTipEscorts);
    } else {
        toastr.error(this.translate.home.errorCommon);
    }

    this.loading = false;
    $('#tipConfirmPurchase').modal('hide');
}

function storeTipMetaAndRedirect() {
    const metaObject = {
        redirectedFrom: 'tipProfileModal',
        tipProfileModalRedirector: {
            tipUsername: this.user.username,
            tipAmount: this.amount,
            tipRedirectProfilePath: window.location.href,
        }
    };

    const expiration = moment().add(30, 'minutes').toISOString();
    this.setLocalStorageObject('loginMeta', metaObject, expiration);

    if (this.isPunter) {
        window.location.href = regionRelativeUrl(NuxtRoutes.CHECKOUT.BUY_CREDITS);
    } else {
        window.location.href = regionRelativeUrl('/users/products/buy-credits/');
    }
}

export default {
    data,
    computed: {
        ...mapState(['translate', 'currentUser']),
        confirmText() {
            if (!this.user) return '';
            return this.translate.account.tips.confirmTipPurchase
                .replace(':username', this.user.username)
                .replace(':amount', this.amount);
        },
    },
    methods: {
        initModal,
        onConfirm,
        storeTipMetaAndRedirect,
        regionRelativeUrl,
    },
    components: {
        GemFilledComponent,
        ButtonWithLoadingComponent,
    },
    mixins: [userMixin, privateGalleriesMixin, localStorageMixin],
    beforeDestroy() {
        window.clearModalFade();
    },
};
</script>
